import { axiosRequest } from 'lib/api/axios';

import { DeviceName } from '../../types/models';
import { KeyPath, KeyPathParser } from '../signalR';

function stateKeepingUrl() {
  return `${global.clientConfig?.StatekeepingUrl}/api/v1/Twin`;
}

export async function fetchTwin<T>(
  keyPath: KeyPath,
  parser: (obj: any) => T,
): Promise<{ data: T }> {
  const { data } = await axiosRequest('get', stateKeepingUrl(), {
    params: {
      ...keyPath,
      path: keyPath.path ?? '$',
    },
  });
  return { data: parser(data) };
}

export async function fetchPostTwin<T>(keyPath: KeyPath, value: T) {
  const { data: success } = await axiosRequest<boolean>('post', stateKeepingUrl(), {
    ...keyPath,
    value,
  });
  return success;
}

export class StateKeepingFetcher {
  // todo - return type is not properly working
  static async _generateFetcher(deviceName: DeviceName, keyPathParser: KeyPathParser) {
    const { keyPath, parser } = keyPathParser;
    const { data } = await fetchTwin(keyPath(deviceName), parser);
    return { data };
  }

  static async getReportedSpotCam(deviceName: DeviceName) {
    const { keyPath, parser } = KeyPathParser.PayloadsSpotCam;
    const { data } = await fetchTwin(keyPath(deviceName), parser);
    return { data };
  }

  // todo- how good is it to just load and than not update this?
  static async getReportedSpotFaults(deviceName: DeviceName) {
    return this._generateFetcher(deviceName, KeyPathParser.SpotFaults);
  }
}
